webpackJsonp([4016850265702045000],{

/***/ "./node_modules/hoist-non-react-statics/index.js":
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/michael/Development/mine/react-arrow/docs/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/michael/Development/mine/react-arrow/docs/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/michael/Development/mine/react-arrow/docs/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/michael/Development/mine/react-arrow/docs/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[\"/Users/michael/Development/mine/react-arrow/docs/node_modules/babel-preset-env/lib/index.js\",\"/Users/michael/Development/mine/react-arrow/docs/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/michael/Development/mine/react-arrow/docs/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _index = __webpack_require__("../index.js");
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Some examples:'
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: {
	          display: 'flex',
	          flexWrap: 'wrap',
	          alignItems: 'flex-start'
	        } },
	      _react2.default.createElement(RotatingSampleArrow, {
	        style: { width: '100px', height: '100px' },
	        angle: 10,
	        length: 50
	      }),
	      _react2.default.createElement(RotatingSampleArrow, {
	        style: { width: '100px', height: '100px' },
	        angle: -87,
	        length: 350,
	        lineWidth: 15
	      }),
	      _react2.default.createElement(RotatingSampleArrow, {
	        style: { width: '100px', height: '100px' },
	        angle: 95,
	        length: 150,
	        color: '#9C27B0',
	        arrowHeadFilled: false
	      }),
	      _react2.default.createElement(RotatingSampleArrow, {
	        style: { width: '100px', height: '100px' },
	        angle: 87,
	        length: 100,
	        color: '#F44336'
	      }),
	      _react2.default.createElement(RotatingSampleArrow, {
	        style: { width: '100px', height: '100px' },
	        angle: 160,
	        length: 60,
	        lineDashed: true
	      }),
	      _react2.default.createElement(RotatingSampleArrow, {
	        style: { width: '100px', height: '100px' },
	        angle: 300,
	        length: 60,
	        lineDashed: "0.9",
	        arrowHeadFilled: false
	      })
	    )
	  );
	};
	
	exports.default = IndexPage;
	
	var RotatingSampleArrow = function (_React$Component) {
	  _inherits(RotatingSampleArrow, _React$Component);
	
	  function RotatingSampleArrow(props) {
	    _classCallCheck(this, RotatingSampleArrow);
	
	    var _this = _possibleConstructorReturn(this, (RotatingSampleArrow.__proto__ || Object.getPrototypeOf(RotatingSampleArrow)).call(this));
	
	    _this.state = {
	      angle: props.angle
	    };
	    return _this;
	  }
	
	  _createClass(RotatingSampleArrow, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var speed = Math.max(10, Math.random() * 100);
	      var direction = Math.random() > 0.5 ? 1 : -1;
	      console.log(speed);
	      this.rotater = window.setInterval(function () {
	        var newAngle = _this2.state.angle + direction;
	        if (newAngle > 360) {
	          newAngle = 360 - newAngle;
	        }
	        if (newAngle < -360) {
	          newAngle = 360 + newAngle;
	        }
	        _this2.setState({ angle: newAngle });
	      }, speed);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.clearInterval(this.rotater);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(SampleArrow, _extends({}, this.props, {
	        angle: this.state.angle
	      }));
	    }
	  }]);
	
	  return RotatingSampleArrow;
	}(_react2.default.Component);
	
	var SampleArrow = function SampleArrow(props) {
	  var style = props.style,
	      relevantProps = _objectWithoutProperties(props, ['style']);
	
	  var styleText = Object.keys(relevantProps).map(function (key) {
	    return key + '=' + relevantProps[key];
	  }).join(', ');
	
	  return _react2.default.createElement(
	    'div',
	    { style: {
	        margin: '10px',
	        width: '200px',
	        textAlign: 'center'
	      } },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_index2.default, props)
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: {
	          fontSize: '14px',
	          display: 'inline-block',
	          color: 'white',
	          background: '#222222',
	          padding: '10px',
	          borderRadius: '4px'
	        } },
	      styleText
	    )
	  );
	};
	module.exports = exports['default'];

/***/ }),

/***/ "../index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // http://thenewcode.com/1068/Making-Arrows-in-SVG
	
	var PolyLineStyle = {
	  fill: 'none'
	  // Not yet sure if this is a good property to set or not
	  //vectorEffect: 'non-scaling-stroke'
	};
	
	var PathStyle = {
	  fill: 'none'
	};
	
	function toRad(d) {
	  return d * Math.PI / 180;
	}
	
	var Arrow = function (_PureComponent) {
	  _inherits(Arrow, _PureComponent);
	
	  function Arrow() {
	    _classCallCheck(this, Arrow);
	
	    var _this = _possibleConstructorReturn(this, (Arrow.__proto__ || Object.getPrototypeOf(Arrow)).call(this));
	
	    if (!_this.constructor.__counter) {
	      _this.constructor.__counter = 1;
	    }
	    _this.uniqid = _this.constructor.__counter++;
	    return _this;
	  }
	
	  _createClass(Arrow, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          length = _props.length,
	          angle = _props.angle,
	          arrowHeadFilled = _props.arrowHeadFilled,
	          lineWidth = _props.lineWidth,
	          lineDashed = _props.lineDashed,
	          otherProps = _objectWithoutProperties(_props, ['length', 'angle', 'arrowHeadFilled', 'lineWidth', 'lineDashed']);
	
	      // By default, our sin math would let the angle rotate to
	      // the left. Reverse the direction.
	
	
	      angle = -angle + 180;
	      angle = angle % 360;
	
	      // Let's do some trig to calculate the viewbox.
	      //
	      // Assuming the arrow points top right, c is the arrow
	      // length, a is the viewbox width, b is the viewbox height.
	
	      // We know C is 90deg
	      var B = angle;
	      var C = 90;
	      var A = 180 - C - B;
	      var c = length;
	
	      // Get all the sides
	      var a = c / Math.sin(toRad(C)) * Math.sin(toRad(A));
	      var b = c / Math.sin(toRad(C)) * Math.sin(toRad(B));
	
	      // a, b can be negative if the angle. We will rewrite
	      // those values to go inside the svg viewbox.
	      var width = Math.abs(b);
	      var height = Math.abs(a);
	
	      var padding = 10;
	
	      // Now we have a viewBox
	      var viewBox = '0 0 ' + (width + padding * 2) + ' ' + (height + padding * 2);
	
	      function point(x, y) {
	        if (b < 0) {
	          x = width + padding * 2 - x;
	        }
	        if (a < 0) {
	          y = height + padding * 2 - y;
	        }
	        return x + ',' + y;
	      }
	
	      var path = ['M' + point(padding, padding), 'L' + point(width + padding, height + padding)];
	
	      // TODO: Cooler line:
	      // M16.7,178 c87.6-46.9,162.9-185.4,227-136.4C307.2,90.1,195,158.5,111,108.9C71,85.2,92.2,30.7,126,7
	
	      var markerId = 'Arrow-pointer-' + this.uniqid;
	
	      // Based on the props, determine the styles.
	      var arrowHeadStyle = _extends({}, PolyLineStyle, {
	        strokeWidth: 0,
	        stroke: this.props.color
	      });
	      if (this.props.arrowHeadFilled) {
	        arrowHeadStyle.fill = this.props.color;
	      } else {
	        arrowHeadStyle.strokeWidth = 1;
	      }
	
	      var lineStyle = _extends({}, PathStyle, {
	        stroke: this.props.color,
	        strokeWidth: this.props.lineWidth
	      });
	
	      if (lineDashed) {
	        if (typeof lineDashed !== 'string') {
	          lineDashed = '11, 5';
	        };
	
	        lineStyle.strokeDasharray = lineDashed;
	      }
	
	      return _react2.default.createElement(
	        'svg',
	        _extends({
	          xmlns: 'http://www.w3.org/2000/svg',
	          viewBox: viewBox
	        }, otherProps),
	        _react2.default.createElement(
	          'defs',
	          null,
	          _react2.default.createElement(
	            'marker',
	            {
	              id: markerId,
	              markerWidth: '9',
	              markerHeight: '9',
	              refX: '8',
	              refY: '5',
	              orient: 'auto',
	              markerUnits: 'strokeWidth' },
	            _react2.default.createElement('polyline', {
	              points: '1 1, 9 5, 1 9',
	              style: arrowHeadStyle
	            })
	          )
	        ),
	        _react2.default.createElement('path', {
	          style: lineStyle,
	          d: path.join(' '),
	          markerEnd: 'url(#' + markerId + ')'
	        })
	      );
	    }
	  }]);
	
	  return Arrow;
	}(_react.PureComponent);
	
	Arrow.propTypes = {
	  length: _react2.default.PropTypes.number,
	  angle: _react2.default.PropTypes.number,
	  color: _react2.default.PropTypes.string,
	  arrowHeadFilled: _react2.default.PropTypes.bool,
	  lineWidth: _react2.default.PropTypes.number,
	  lineDashed: _react2.default.PropTypes.oneOf([_react2.default.PropTypes.bool, _react2.default.PropTypes.string])
	};
	Arrow.defaultProps = {
	  angle: 0,
	  length: 50,
	  color: '#231F20',
	  arrowHeadFilled: true,
	  lineWidth: 1,
	  lineDashed: false
	};
	exports.default = Arrow;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// page-component---src-pages-index-js-7b3f434d6fe3e219319b.js